import Layout from '../Components/Layout/Layout';

const Privacy = () => {
    return (
        <Layout>
            <div className="max-w-4xl mx-auto px-4 py-0 md:py-8">
                <h1 className="text-2xl font-bold text-ps-blue-dark mb-8">Privacy Statement PS in foodservice</h1>
                <div className="prose prose-sm max-w-none">
                    <div className="bg-white p-0 space-y-6">
                        <p className="text-gray-600">
                            Dit is het privacy statement van Besloten Vennootschap PS in foodservice. PS in foodservice is ingeschreven bij de Kamer van Koophandel onder nummer 09088933 en is gevestigd aan Nieuwe Kazernelaan 2 D 41 Unit A1 (6711 JC) te EDE.
                        </p>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Verkrijging persoonsgegevens</h2>
                            <p className="text-gray-600">
                                Bij gebruik van onze diensten verstrek je zelf persoonsgegevens of worden deze verkregen in het kader van de overeenkomst.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Categorieën persoonsgegevens</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Contact- en NAW-gegevens</li>
                                <li>Bedrijfsgegevens (BTW-nummer, KvK-nummer)</li>
                                <li>Afwijkend afleveradres</li>
                                <li>Financiële gegevens</li>
                                <li>Accountgegevens</li>
                                <li>Overige zelf verstrekte gegevens</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Doel van de verwerking</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Contact voor informatieverstrekking over diensten</li>
                                <li>Uitvoering van diensten</li>
                                <li>Verbetering dienstverlening</li>
                                <li>Betalingsverwerking</li>
                                <li>Wettelijke verplichtingen</li>
                                <li>Marketing en communicatie</li>
                                <li>Versturen nieuwsbrieven</li>
                                <li>Gegevensuitwisseling met derden indien noodzakelijk</li>
                            </ul>
                        </section>
                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Grondslag verwerking</h2>
                            <p className="text-gray-600">
                                Persoonsgegevens worden verwerkt op grond van: (i) wettelijke verplichting, (ii) uitvoering overeenkomst, (iii) verkregen toestemming, en (iv) gerechtvaardigd belang. De grondslag is primair de overeenkomst die je met PS in foodservice bent aangegaan.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Noodzaak verwerking</h2>
                            <p className="text-gray-600">
                                De verwerking van je persoonsgegevens is noodzakelijk voor het uitvoeren van onze dienstverlening. Zonder deze gegevens kunnen de diensten niet volledig worden uitgevoerd.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Geautomatiseerde besluitvorming</h2>
                            <p className="text-gray-600">
                                Bij geautomatiseerde besluitvorming is de betrokkene zelf verantwoordelijk voor de juistheid van verstrekte gegevens. Schade door onjuiste of onvolledige gegevens komt voor rekening van de betrokkene.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Bewaartermijn</h2>
                            <p className="text-gray-600">
                                Persoonsgegevens worden bewaard conform relevante wet- en regelgeving. Bij een langere wettelijke bewaartermijn worden de gegevens conform deze eisen bewaard.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Verwerking door derden</h2>
                            <div className="space-y-4 text-gray-600">
                                <p>Persoonsgegevens worden alleen gedeeld met:</p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>Bezorgdiensten (contact- en NAW-gegevens)</li>
                                    <li>Payment Provider (financiële gegevens)</li>
                                    <li>Boekhouder (contact-, NAW- en financiële gegevens)</li>
                                    <li>Softwareleveranciers (contact- en NAW-gegevens)</li>
                                    <li>Websitebeheerder (contact- en NAW-gegevens)</li>
                                    <li>Ingeschakelde derden (contact- en NAW-gegevens)</li>
                                </ul>
                            </div>
                        </section>
                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Beveiliging van Persoonsgegevens</h2>
                            <p className="text-gray-600">
                                PS in foodservice neemt passende technische en organisatorische maatregelen om je persoonsgegevens te beschermen.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Jonger dan 16 jaar?</h2>
                            <p className="text-gray-600">
                                Voor minderjarigen onder 16 jaar is toestemming van ouders of wettelijke voogd vereist voor gegevensverwerking.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Recht van betrokkenen</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Recht op inzage</li>
                                <li>Recht op rectificatie</li>
                                <li>Recht op gegevenswissing</li>
                                <li>Recht op beperking van verwerking</li>
                                <li>Recht op overdraagbaarheid</li>
                                <li>Recht van bezwaar</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Klacht</h2>
                            <p className="text-gray-600">
                                Klachten over gegevensverwerking kun je indienen via support@psinfoodservice.com. PS in foodservice reageert binnen 4 weken. U kunt ook een klacht indienen bij de Autoriteit Persoonsgegevens.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Wijzigingen Privacy Statement</h2>
                            <p className="text-gray-600">
                                PS in foodservice kan dit privacy statement aanpassen. De meest recente versie staat op de website.
                            </p>
                        </section>

                        <div className="mt-8 text-sm text-gray-500">
                            <p>Ede, 1 december 2024</p>
                        </div>




                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Privacy;